var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 162,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 307,
    width: 162,
    height: 162
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-53 -307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.5 377.875 144.125 377.875 144.125 320.5 123.875 320.5 123.875 377.875 66.5 377.875 66.5 398.125 123.875 398.125 123.875 455.5 144.125 455.5 144.125 398.125 201.5 398.125Z",
    fill: "#203864"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAis);
export default __webpack_public_path__ + "static/media/AIS.8ccc3b694d0ab1ee1ad502483a489f89.svg";
export { ForwardRef as ReactComponent };